import styled from 'styled-components';

export const ListLabel = styled('div')`
  margin-left: ${(p) => p.theme.spacing(2)};
  display: flex;
  flex-flow: nowrap column;
  justify-content: center;
`;
